import { render, staticRenderFns } from "./ApplyType.vue?vue&type=template&id=cbebdfe2&scoped=true&"
import script from "./ApplyType.vue?vue&type=script&lang=ts&"
export * from "./ApplyType.vue?vue&type=script&lang=ts&"
import style0 from "./ApplyType.vue?vue&type=style&index=0&id=cbebdfe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbebdfe2",
  null
  
)

export default component.exports